module.exports = __webpack_public_path__ + "img/chatu.67b37de.png";